import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import QuickOrderMobileProductCard from './QuickOrderMobileProductCard';
import useDebouncedOnChange from '../../Hooks/useDebouncedOnChange';
import {
  QuickOrderActions,
  getProduct,
} from '../../Reducers/QuickOrder.reducer';
import { useDispatch } from 'react-redux';
import Icon from '../Icon';
import Input from '../Inputs/Input';
import { useDebouncedCallback } from 'use-debounce';

const QuickOrderMobileTable = () => {
  const { result, addNewRow, formattedPrice } = useTypedSelector(
    (state) => state.QuickOrderReducer
  );
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState<String | undefined>(
    undefined
  );

  const debouncedSearchQuery = useDebouncedCallback((value) => {
    if (value && value !== '') {
      setSearchQuery(value);
    }
  }, 1000);

  useEffect(() => {
    if (searchQuery) {
      dispatch(getProduct(searchQuery));
    }
  }, [searchQuery, dispatch]);

  return (
    <div className="w-full rounded border-x border-y border-gray-200 bg-gray-50 lg:hidden">
      {result &&
        result.map((item) => {
          return (
            <QuickOrderMobileProductCard
              key={'mobile' + item.uniqueId}
              product={item}
            />
          );
        })}
      {addNewRow && (
        <div className="flex w-full flex-col border-b border-gray-200">
          <div className="flex w-full gap-4 p-3">
            <div className="flex w-full items-center text-md leading-tight text-gray-500">
              <Input
                placeholder={translate('quick-order.article-nr')}
                onChange={(e) => {
                  debouncedSearchQuery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col items-center justify-between gap-3 px-3 py-3">
        <button
          className="flex w-full flex-1 cursor-pointer items-center justify-center gap-2 rounded-md border border-solid border-gray-700 px-4 py-2 text-center text-sm font-normal uppercase"
          onClick={() => dispatch(QuickOrderActions.setAddNewRow())}
        >
          <Icon name="plus" className="h-5 w-5" />
          {translate('quick-order.add-row')}
        </button>
        {formattedPrice && (
          <div className="flex w-full flex-row justify-between">
            <h3>{translate('quick-order.total-sum')}</h3>
            <h3>{formattedPrice}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickOrderMobileTable;
